import { render } from "./MainSideHeader.vue?vue&type=template&id=014cc237&scoped=true"
import script from "./MainSideHeader.vue?vue&type=script&lang=js"
export * from "./MainSideHeader.vue?vue&type=script&lang=js"

import "./MainSideHeader.vue?vue&type=style&index=0&id=014cc237&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014cc237"]])

export default __exports__